import type { GetAllWithNamesOptions, TSimpleUnit } from '../../../shared/domain/units/types.no-deps'
import type { Endpoint, Route, Request, RequestArgs } from '../types.no-deps'

export const route: Route = { method: 'POST', pattern: '/api/unitsWithNames' }

type Params = never
type Body = {
    unitIds?: number[]
}

type Query = Omit<GetAllWithNamesOptions, 'unitIds'>
type Output = { units: Array<TSimpleUnit & { id: number; lastMod: Date }> }

// Since I cannot reuse the name GetAllWithNamesEndpoint, I will use GetManyWithNamesEndpoint instead
export type GetManyWithNamesEndpoint = Endpoint<Params, Body, Query, Output>

export const getManyWithNamesRequest = (request: Request, args: RequestArgs<GetManyWithNamesEndpoint>) =>
    request<GetManyWithNamesEndpoint>(route, args)
